import { ErrorBottomSheet as UIErrorBottomSheet, type ErrorBottomSheetProps } from '@jagad/ui'
import { useTranslation } from 'react-i18next'

type Props = Omit<ErrorBottomSheetProps, 'tryAgainLabel' | 'contactUsLabel'>

const ErrorBottomSheet = (props: Props) => {
    const { t } = useTranslation()
    return (
        <UIErrorBottomSheet
            {...props}
            tryAgainLabel={t('components.errorBottomSheet.tryAgain')}
            contactUsLabel={t('components.errorBottomSheet.contactUs')}
        />
    )
}

export default ErrorBottomSheet
